import { Button, styled } from '@mui/material';

export const NavbarMemberSubButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.grey[250],
  justifyContent: 'flex-start',
  fontWeight: 'normal',
  padding: '5px 0',
  paddingLeft: '41px',
  borderRadius: '4px',
  fontSize: '14px',
  whiteSpace: 'pre-line',
  textAlign: 'left',
  width: '100%',
  ':hover': {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  // focus時に太字にする
  ':focus': {
    fontWeight: 'bold',
  },
}));
